var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oae-container"},[_c('iframe',{staticClass:"oae-iframe",attrs:{"src":"https://pad.machao.group/","frameborder":"0","title":"Machao Pad","sandbox":"allow-same-origin allow-scripts allow-forms allow-popups","referrerpolicy":"no-referrer"}})])
}]

export { render, staticRenderFns }